import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchInventoryOrderList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/inventoryOrder/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchInventoryOrderList', payload)
            } else {
                commit('setInventoryOrderList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchInventoryOrderRequest = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/inventoryOrder/fetchInventoryOrderRequest.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {      
            if(res.data.try_again) {
                dispatch('fetchInventoryOrderRequest', payload)
            } else {
                commit('setInventoryOrderRequestList', res.data.response)         
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const submitPurchaseRequestApprove = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/inventoryOrder/submitPurchaseRequestApprove.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {      
        console.log(JSON.stringify(res.data))
        commit('togglePruchaseRequestApprovalStatus', payload.list)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteInventoryOrderRequest = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/inventoryOrder/deleteInventoryOrderRequest.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        dispatch('fetchInventoryOrderRequest', payload)            
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchInventoryOrderData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/inventoryOrder/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            
            commit('setInventoryOrderData', {response: res.data.response, copy: payload.copy})   
            
            if(payload.navigate) {
                setTimeout(() => {
                    router.push(router.currentRoute.fullPath+'/form/')
                }, 200);
                //
            }
            
        } else {
            commit('resetInventoryOrderData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitInventoryOrderData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryOrder/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {       
        console.log(JSON.stringify(res.data)) 
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0 && !payload.popup) {
                //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            dispatch('fetchInventoryOrderData', {id: res.data.id})
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteInventoryOrderData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryOrder/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else if(payload.popup) {
            } else {
                dispatch('fetchInventoryOrderList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryOrder/actions.js